module.exports = __webpack_public_path__ + "img/page_control.8483affa.svg";